import React from 'react';

const BCBusinessSectorFormModal = React.lazy(() => import('../components/FormModal'));
const bCBusinessSectorModalRegistry = {
    company_bcBusinessSectorId: BCBusinessSectorFormModal
};
export default bCBusinessSectorModalRegistry;
